export default __webpack_public_path__ + "static/media/news.8e9e5396.svg";